export default __webpack_public_path__ + "static/media/01_Business-Portrait-EschweilerPhotography_21A9561.680c2067.jpg";